import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_create_materials_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { materials: $frontendTypes.FootprintApiManager.input_create_material[] }): Promise<{ materials?: $frontendTypes.FootprintApiManager.public_material[], errors?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materials)) {
      $missingRequiredInParams.push('\'materials\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/materials/create`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

